import axios from 'axios';
import UserService from '../../../base/components/Keycloak/UserService';

export const AdminHandler = {
    getAllUsers: function(userId){
        return new Promise(function(resolve, reject){

            if(!userId){
                return reject();
            }

            axios.get(window.config.vendor.api + "/modelviewer/getAllUsers?userId=" + userId)
            .then(function (response) {
                const data = response.data;
                if(data.Success){
                    resolve(data);
                }else{
                    reject(data);
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err);
            })
        })},
    getAllCompanies: function(userId){
        return new Promise(function(resolve, reject){
        if(!userId){
            return reject();
        }

        axios.get(window.config.vendor.api + "/modelviewer/getCompanies?userId=" + userId)
            .then(function (response) {
                const data = response.data;
                if(data.Success){
                    resolve(data);
                }else{
                    reject(data);
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err);
            })
        })},   
        
    addCompany: function(userId, companyName, modelLimit, userLimit, appAccess = false, rapid = false){
        return new Promise(function(resolve, reject){

        if(!userId || !companyName){
            
            reject();
            return;
        }
        if (!modelLimit) modelLimit = 0;
        if (!userLimit) userLimit = 0;
        
        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("companyName", companyName);
        formData.append("modelLimit", modelLimit);
        formData.append("userLimit", userLimit);
        formData.append("appAccess", appAccess ? 1 : 0);
        formData.append("rapid", rapid ? 1 : 0);              
    
        // Request made to the backend api
        // Send formData object
        axios.post(window.config.vendor.api + "/modelviewer/addCompany", formData)
        .then(function (response) {                
            const data = response.data;
            if(data.Success){
                console.log("hello");
                resolve(data);
            }else{
                console.log("not success");
                reject(data);
            }
        })
        .catch((err) => {
            console.log("error");
            reject(err);
        })
    })},

    remCompany: function(userId, companyGuid){
        return new Promise(function(resolve, reject){
        if(!userId || !companyGuid){
            return reject();
        }
        const formData = new FormData();
        formData.append("userId", userId);
        formData.append("companyGuid", companyGuid);
        // Request made to the backend api
        // Send formData object
        axios.post(window.config.vendor.api + "/modelviewer/remCompany", formData)
            .then(function (response) {                
                const data = response.data;
                if(data.Success){
                    resolve(data);
                }else{
                    reject(data);
                }
            })
            .catch((err) => {
                reject(err);
            })
    })},

    updateUserRole: function(NewRole, UserEmail){
        return new Promise(function(resolve, reject){
    
            if(!UserEmail || !NewRole){
                return reject();
            }
            
            const formData = new FormData();
            formData.append("UserEmail", UserEmail);
            formData.append("UserRole", NewRole);
                        
        
            // Request made to the backend api
            // Send formData object
            axios.post(window.config.vendor.api + "/modelviewer/updateUserRole", formData)
            .then(function (response) {                
                const data = response.data;
                if(data.Success){
                    resolve(data);
                }else{
                    reject(data);
                }
            })
            .catch((err) => {
                reject(err);
            })
        }
    )},
    addUserWithPassword: function(userName, UserEmail, UserLocale, UserRole, CompanyGuid, CompanyName, Password){
        return new Promise(function(resolve, reject){                
            var userId = UserService.SessionData.getUserID();
            if(!userId || !userName || !UserEmail|| !CompanyGuid){
                return reject();
            }
            const formData = new FormData();
            formData.append("instigatorId", userId);
            formData.append("userName", userName);
            formData.append("userEmail", UserEmail);
            formData.append("userLocale", UserLocale);
            formData.append("companyGuid", CompanyGuid);
            formData.append("userRole", UserRole);
            formData.append("password", Password);
            // Request made to the backend api
            // Send formData object
            axios.post(window.config.vendor.api + "/keycloak/createNewVithroughUserPassword", formData)
            .then(function (response) {              
                const data = response.data;
                if(data.Success){
                    resolve(data);
                }
                else{
                    reject(data);
                }
            })
            .catch((err) => {
                console.log(err)
                reject(err);
            })}
        )},
        addUser: function(userName, UserEmail, UserLocale, UserRole, CompanyGuid){
            return new Promise(function(resolve, reject){                
                var userId = UserService.SessionData.getUserID();
                if(!userId || !userName || !UserEmail|| !CompanyGuid)
                {
                    return reject();
                }
                const formData = new FormData();                    
                formData.append("instigatorId", userId);
                formData.append("userName", userName);
                formData.append("userEmail", UserEmail);
                formData.append("userLocale", UserLocale);
                formData.append("companyGuid", CompanyGuid);
                formData.append("userRole", UserRole);
        
                // Request made to the backend api
                // Send formData object
                axios.post(window.config.vendor.api + "/keycloak/createNewVithroughUser", formData)
                    .then(function (response) {                
                        const data = response.data;
                        if(data.Success){
                            resolve(data);
                        }
                        else{
                            reject(data);
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    }
                );
            })},
            remUser: function(userId){
                return new Promise(function(resolve, reject){
        
                if(!userId){
                    return reject();
                }
                var adminuser = UserService.SessionData.getUserID();
                const messageData = new FormData();
                messageData.append("UserID", userId);
                messageData.append("AdminUserID", adminuser);
                axios.post(
                    window.config.host.api + "/modelviewer/removeUser", messageData
                    ).then((res) => {
                        if (res.data.Success) {
                            resolve(res);
                        }
                        else {
                            reject(res.data);
                        }                                         
                    }).catch((e) => {
                        console.error("Failed to remove user.", e)
                        reject(e)
                })        
            })},
            updateCompanyLimit: function(companyId, newLimit){
                return new Promise(function(resolve, reject){
        
                if(!companyId || !newLimit){
                    return reject("unset values");
                }
                const messageData = new FormData();
                messageData.append("CompanyGuid", companyId);
                messageData.append("ModelLimit", newLimit);
                axios.post(
                    window.config.host.api + "/modelviewer/updateCompanyLimit", messageData
                    ).then((res) => {
                        if (res.data.Success) {                           
                            resolve(res);

                        }
                        else {
                            reject(res.data);
                        }                                         
                    }).catch((e) => {                        
                        reject(e)
                })        
            })},
            updateUserLimit: function(companyId, newLimit){
                return new Promise(function(resolve, reject){
        
                if(!companyId || !newLimit){
                    return reject("unset values");
                }
                const messageData = new FormData();
                messageData.append("CompanyGuid", companyId);
                messageData.append("UserLimit", newLimit);
                axios.post(
                    window.config.host.api + "/modelviewer/updateUserLimit", messageData
                    ).then((res) => {
                        if (res.data.Success) {                           
                            resolve(res);
                        }
                        else {
                            reject(res.data);
                        }                                         
                    }).catch((e) => {                        
                        reject(e)
                })        
            })},
            updateCompanyAppAccess: function(companyId, appaccess){
                return new Promise(function(resolve, reject){
        
                if(!companyId){
                    return reject("unset values");
                }
                const messageData = new FormData();
                messageData.append("CompanyGuid", companyId);
                messageData.append("AppAccess", appaccess ? "1" : "0");
                axios.post(
                    window.config.host.api + "/modelviewer/updateCompanyAppAccess", messageData
                    ).then((res) => {
                        if (res.data.Success) {                           
                            resolve(res);

                        }
                        else {
                            reject(res.data);
                        }                                         
                    }).catch((e) => {                        
                        reject(e)
                })        
            })},
            updateCompanyRapidAccess: function(companyId, rapidAccess){
                return new Promise(function(resolve, reject){
        
                if(!companyId){
                    return reject("unset values");
                }
                const messageData = new FormData();
                messageData.append("CompanyGuid", companyId);
                messageData.append("RapidAccess", rapidAccess ? "1" : "0");
                axios.post(
                    window.config.host.api + "/modelviewer/updateCompanyRapidAccess", messageData
                    ).then((res) => {
                        if (res.data.Success) {                           
                            resolve(res);

                        }
                        else {
                            reject(res.data);
                        }                                         
                    }).catch((e) => {                        
                        reject(e)
                })        
            })},
            updateCompanyTFAPolicy: function(companyId, tfaPolicy){
                return new Promise(function(resolve, reject){
        
                if(!companyId){
                    return reject("unset values");
                }
                const messageData = new FormData();
                messageData.append("CompanyGuid", companyId);
                messageData.append("TfaPolicy", tfaPolicy ? "1" : "0");
                axios.post(
                    window.config.host.api + "/modelviewer/updateCompanyTFAPolicy", messageData
                    ).then((res) => {
                        if (res.data.Success) {                           
                            resolve(res);
                        }
                        else {
                            reject(res.data);
                        }
                    }).catch((e) => {
                        reject(e)
                })
            })},
            ResetTOTP: function(email, realmHash){
                return new Promise(function(resolve, reject){
                if(email == null || email === ""){
                    return reject();
                }
                const messageData = new FormData();
                messageData.append("UserMail", email);
                messageData.append("RealmHash", window.config.host.pre === "" ? realmHash : `${window.config.host.pre}_` + realmHash);
                axios.post(
                    window.config.host.api + "/keycloak/postResetTOTP", messageData
                    ).then((res) => {
                        if (res.data.Success) {
                            resolve();
                        }
                        else {
                            reject(res.data);
                        }
                    }).catch((e) => {
                        console.error("Failed to reset TOTP.", e)
                        reject(e)
                })
            })},

}